module.exports = __webpack_public_path__ + "img/lk.d01b7027.svg";